
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(0250|1118|1984)|3(2869|6710|8532)|28335|85616)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
